/* Suggestions for the Copilot panel's empty state, from counts already in memory. Pure, so it is testable. */

const MAX_SUGGESTIONS = 3;
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
const count = v => (typeof v === "number" && v > 0 ? v : 0);

// Highest value first; the first three that apply are shown.
export const buildSuggestions = ({ pageFinding, tasksLate, tasksToday, inboxUnread, signalsNew, agentsNeedYou }) => {
  const out = [];
  if (pageFinding) {
    out.push({ key: "page", text: pageFinding, prompt: `On this page: ${pageFinding} What should I do about it?` });
  }
  if (count(tasksLate)) {
    out.push({ key: "late", text: `Who should I call first? ${plural(tasksLate, "task is", "tasks are")} overdue`, prompt: "Who should I call today?" });
  } else if (count(tasksToday)) {
    out.push({ key: "today", text: `Plan my day: ${plural(tasksToday, "task", "tasks")} due today`, prompt: "What tasks are due today, and what order should I do them in?" });
  }
  if (count(inboxUnread)) {
    out.push({ key: "inbox", text: `Catch up on ${plural(inboxUnread, "unread reply", "unread replies")}`, prompt: "Summarize my unread replies and what each one needs" });
  }
  if (count(signalsNew)) {
    out.push({ key: "signals", text: `What's behind ${plural(signalsNew, "new signal", "new signals")}?`, prompt: "Which of my accounts are heating up right now, and why?" });
  }
  if (count(agentsNeedYou)) {
    out.push({ key: "agents", text: `${plural(agentsNeedYou, "agent needs", "agents need")} you: what's waiting?`, prompt: "Which of my agents need my attention, and what do they need?" });
  }
  // Quiet workspace: still useful, never empty.
  out.push({ key: "week", text: "What changed this week?", prompt: "What changed this week?" });
  out.push({ key: "top", text: "Which companies have the most contacts?", prompt: "Which 5 companies have the most contacts?" });
  return out.slice(0, MAX_SUGGESTIONS);
};
